/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { setCidade, setAuthToken, getTotem } from '../../api/apiFactory';
import {
  fetchLimparCookie, fetchVerificarStatusCidade,
  fetchNomeCidade, fetchSecretarias,
} from '../../api/endpoints';
import {
  definirCidade, fetchConfiguracoesCidade, selectCidade, desfazerCidade,
} from '../../app/slices/cidadesSlice';
import { desfazerConexao, selectLogin } from '../../app/slices/loginSlice';
import {
  abrirModalAjuda, abrirModalLoginManifestacao, resetarModais, selectModal,
} from '../../app/slices/modalSlice';
import { definirSecretaria, desfazerSecretaria, selectSecretaria } from '../../app/slices/secretariasSlice';
import AppHeader from '../../components/AppHeader/AppHeader';
import Botao from '../../components/Botao/Botao';
import Carregar from '../../components/Carregar/Carregar';
import FormularioManifestacao from '../../components/FormularioManifestacao/FormularioManifestacao';
import GridBotao from '../../components/GridBotao/GridBotao';
import ModalAjuda from '../../components/ModalAjuda/ModalAjuda';
import ModalContato from '../../components/ModalContato/ModalContato';
import ModalEnquete from '../../components/ModalEnquete/ModalEnquete';
import ModalLogin from '../../components/ModalLogin/ModalLogin?v=2023-04-19T16:50:00';
import VisualizadorArquivos from '../../components/VisualizadorArquivos/VisualizadorArquivos';
import {
  AppBody, AppFragment, Container, Divisor, Grid, Titulo, TituloAjuda,
} from '../../styles/base';
import { isCorClara } from '../../util/color';
import ModalEscolhaLoginTotem from '../../components/ModalEscolhaLoginTotem/ModalEscolhaLoginTotem';
import ModalLoginTotem from '../../components/ModalLoginTotem/ModalLoginTotem';
import ModalProtocolo from '../../components/ModalProtocolo/ModalProtocolo';
import ModalAnonimo from '../../components/ModalAnonimo/ModalAnonimo';
import ModalBairro from '../../components/ModalBairro/ModalBairro';
import ModalAssunto from '../../components/ModalAssunto/ModalAssunto';
import ModalCategoria from '../../components/ModalCategoria/ModalCategoria';
import ModalUnidade from '../../components/ModalUnidade/ModalUnidade';
import { LinhaForm3 } from '../../components/FormControl/FormControlEstilo';
import FormControl from '../../components/FormControl/FormControl';

const IniciarOuvidoria = () => {
  const [listaSecretarias, setListaSecretarias] = useState(null);
  const [assunto, setAssunto] = useState('');

  const dadosSecretaria = useSelector(selectSecretaria);
  const dadosCidade = useSelector(selectCidade);
  const dadosModal = useSelector(selectModal);
  const dadosLogin = useSelector(selectLogin);

  const dispatch = useDispatch();
  const history = useHistory();

  const [carregando, setCarregando] = useState(false);

  window.onload = () => {
    dispatch(resetarModais());
  };

  const { search } = useLocation();

  const cookie = document.cookie ? document.cookie : null;
  const cookieSeparado = cookie ? cookie.split('&') : null;
  const cookieSelecionado = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('Id2')) : null;
  const cookieSelecionadoSeparado = cookieSelecionado ? cookieSelecionado.split('=') : null;
  const cookieId = cookieSelecionadoSeparado
    ? cookieSelecionadoSeparado[cookieSelecionadoSeparado.length - 1]
    : null;

  const cookieSelecionado2 = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('IdeCrie')) : null;
  const cookieSelecionadoSeparado2 = cookieSelecionado2 ? cookieSelecionado2.split('=') : null;
  const cookieIdEcrie = cookieSelecionadoSeparado2
    ? cookieSelecionadoSeparado2[cookieSelecionadoSeparado2.length - 1]
    : null;

  const cookieSelecionado3 = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('IdeSipe')) : null;
  const cookieSelecionadoSeparado3 = cookieSelecionado3 ? cookieSelecionado3.split('=') : null;
  const cookieIdEsipe = cookieSelecionadoSeparado3
    ? cookieSelecionadoSeparado3[cookieSelecionadoSeparado3.length - 1]
    : null;

  const limpaLoginAnonimo = (data) => {
    if (data && data.data && data.data.anonimo === 'anonimo') {
      setAuthToken(null);
      dispatch(desfazerConexao());
    }
  };

  const checaCidadeAtiva = (id) => {
    if (id) {
      fetchVerificarStatusCidade(id).then((response) => {
        if (response === 'N') {
          dispatch(desfazerConexao());
          dispatch(desfazerCidade());
          dispatch(desfazerSecretaria());
          limpaLoginAnonimo(dadosLogin);
          history.push('/');
        }
      });
    } else {
      history.push('/');
    }
  };

  const escolherCidade = async (Id, IdeCrie, IdeSipe, Campo, Brasao) => {
    setListaSecretarias(null);
    setCidade({
      Id, IdeCrie, IdeSipe, Campo,
    });
    dispatch(definirCidade({
      idCidade: Id,
      idCidadeEcrie: IdeCrie,
      idCidadeEsipe: IdeSipe,
      nomeCidade: Campo,
      brasaoCidade: Brasao,
    }));
    await fetchLimparCookie();
    await dispatch(fetchConfiguracoesCidade());
    await fetchSecretarias().then(setListaSecretarias);
  };

  const pesquisarSecretariaPorAssunto = (event) => {
    event.preventDefault();
    setCarregando(true);
    fetchSecretarias(assunto).then(setListaSecretarias);
    setCarregando(false);
  };

  useEffect(() => {
    if (getTotem() === 'true') {
      // setTimeout(() => {
      //   document.querySelector('body').click();
      //   document.querySelector('body').focus();
      //   document.querySelector('body').click();
      // }, 2000);

      history.push('/totem');
    }

    if (search && search.includes('&id=')) {
      const idCidade = search.split('&id=')[1];
      dispatch(desfazerConexao());
      dispatch(desfazerCidade());
      dispatch(desfazerSecretaria());
      limpaLoginAnonimo(dadosLogin);
      fetchNomeCidade(idCidade).then((nomeCidade) => { escolherCidade(idCidade, 0, 0, nomeCidade); });
    }

    if (cookieId) {
      dispatch(desfazerConexao());
      dispatch(desfazerCidade());
      dispatch(desfazerSecretaria());
      limpaLoginAnonimo(dadosLogin);
      fetchNomeCidade(cookieId).then((nomeCidade) => { escolherCidade(cookieId, cookieIdEcrie, cookieIdEsipe, nomeCidade); });
    }
    if (dadosCidade.data) {
      fetchSecretarias().then(setListaSecretarias);
    }

    if (getTotem() !== 'true') checaCidadeAtiva(dadosCidade && dadosCidade.data && dadosCidade.data.idCidade);
  }, []);

  if (!listaSecretarias) {
    return (
      <Carregar />
    );
  }

  if (dadosCidade.data && !dadosSecretaria.data) {
    const selecionarSecretaria = (Id, Campo, CorHtml) => {
      // 10534: Passe Livre Estudantil em Juiz de Fora.
      // Não permitindo que o usuário entre no formulário da manifestação estando "Logado" como anônimo (anonimo = 'anonimo'). Dito isso, irá abrir o modal de cadastro/login.
      // Com o redirect: true, eu faço que após o login/cadastro, já abra diretamente a página do formulário ao invés da página inicial.
      if (Id === '10534' && (!dadosLogin.data || dadosLogin.data.anonimo === 'anonimo')) {
        return dispatch(abrirModalLoginManifestacao({
          idSecretaria: Id,
          nomeSecretaria: Campo,
          corSecretaria: CorHtml,
          redirect: true,
        }));
      }

      if (!dadosLogin.data) {
        return dispatch(abrirModalLoginManifestacao({
          idSecretaria: Id,
          nomeSecretaria: Campo,
          corSecretaria: CorHtml,
        }));
      }

      if (dadosLogin.data.anonimo === 'naoanonimo') {
        return dispatch(definirSecretaria({
          idSecretaria: Id,
          nomeSecretaria: Campo,
          corSecretaria: CorHtml,
        }));
      }

      if (dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'N') {
        return dispatch(abrirModalLoginManifestacao({
          idSecretaria: Id,
          nomeSecretaria: Campo,
          corSecretaria: CorHtml,
        }));
      }

      return dispatch(definirSecretaria({
        idSecretaria: Id,
        nomeSecretaria: Campo,
        corSecretaria: CorHtml,
      }));
    };

    return (
      <AppFragment
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            dispatch(resetarModais());
          }
        }}
        tabIndex="0"
      >
        {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
        {dadosModal.modalLoginTotem === 'aberto' && (<ModalLoginTotem />)}
        {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
        {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
        {dadosModal.modalAjuda === 'aberto' && (<ModalAjuda />)}
        {dadosModal.modalBairro === 'aberto' && (<ModalBairro />)}
        {dadosModal.modalProtocolo === 'aberto' && (<ModalProtocolo />)}
        {dadosModal.modalEscolhaLoginTotem === 'aberto' && (<ModalEscolhaLoginTotem />)}
        <AppHeader />
        {(dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.WhatsApp) && (getTotem() !== 'true') && (
          <a href={`https://wa.me/55${dadosCidade.configuracoes.WhatsApp.replace(' ', '').replace('-', '').replace('(', '').replace(')', '')}`} target="_blank" rel="noreferrer">
            <Botao whats2 />
          </a>
        )}

        <Botao
          onClick={() => dispatch(abrirModalAjuda())}
          ajuda
        />
        <AppBody desfoque={dadosModal.desfoque} className="controle-fundo">
          <Container totem={getTotem() === 'true'}>
            <Titulo totem={getTotem() === 'true'}>Ouvidoria - Cadastro de manifestação</Titulo>

            <LinhaForm3>
              <FormControl
                idCampo="inputAssunto"
                value={assunto}
                label="Assunto:"
                onChange={({ target }) => setAssunto(target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    pesquisarSecretariaPorAssunto(e);
                  }
                }}
              />

              {carregando !== true
                ? (
                  <Botao
                    label="Pesquisar"
                    type="submit"
                    onClick={pesquisarSecretariaPorAssunto}
                    busca
                  />
                )
                : (
                  <Carregar />
                )}
            </LinhaForm3>

            <Divisor size="pequeno" />

            {dadosCidade.configuracoes.TituloAjudaOuvidoria && (
              <>
                <TituloAjuda>
                  <div dangerouslySetInnerHTML={{ __html: dadosCidade.configuracoes.TituloAjudaOuvidoria }} />
                </TituloAjuda>

                <Divisor size="pequeno" />
              </>
            )}

            {listaSecretarias.Message ? (
              <p>Não há nenhuma secretaria disponível.</p>
            ) : (
              <Grid>
                {listaSecretarias && listaSecretarias.length > 0 && listaSecretarias.map(({
                  Campo, Id, Icone, CorHtml,
                }) => (
                  (Icone === 'cincatarina' || Icone === 'conminas' ? (
                    <GridBotao
                      onClick={() => selecionarSecretaria(Id, Campo, CorHtml)}
                      key={Id}
                      label={Campo}
                      title={Campo}
                      img={`https://eouve.com.br/svg_icons/dark/${Icone}.png`}
                      size={14}
                      imgWidth={120}
                      imgHeight="unset"
                      cor="#ffffff"
                      secretaria
                      className="controle-secretaria"
                    />
                  ) : (
                    <GridBotao
                      onClick={() => selecionarSecretaria(Id, Campo, CorHtml)}
                      key={Id}
                      label={Campo}
                      title={Campo}
                      img={`https://eouve.com.br/svg_icons/${isCorClara(CorHtml) ? 'dark' : 'light'}/${Icone}.svg`}
                      size={14}
                      imgWidth={50}
                      imgHeight={50}
                      cor={CorHtml}
                      secretaria
                      className="controle-secretaria"
                    />
                  ))
                ))}
              </Grid>
            )}
          </Container>
        </AppBody>
      </AppFragment>
    );
  }

  return (
    <AppFragment
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          dispatch(resetarModais());
        }
      }}
      tabIndex="0"
    >
      {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
      {dadosModal.modalLoginTotem === 'aberto' && (<ModalLoginTotem />)}
      {dadosModal.modalEscolhaLoginTotem === 'aberto' && (<ModalEscolhaLoginTotem />)}
      {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
      {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
      {dadosModal.modalArquivo === 'aberto' && (<VisualizadorArquivos />)}
      {dadosModal.modalBairro === 'aberto' && (<ModalBairro />)}
      {dadosModal.modalAssunto === 'aberto' && (<ModalAssunto />)}
      {dadosModal.modalCategoria === 'aberto' && (<ModalCategoria />)}
      {dadosModal.modalUnidade === 'aberto' && (<ModalUnidade />)}
      {dadosModal.modalProtocolo === 'aberto' && (<ModalProtocolo />)}
      {dadosModal.modalAnonimo === 'aberto' && (<ModalAnonimo />)}
      <AppHeader />
      <AppBody desfoque={dadosModal.desfoque} className="controle-fundo">
        <FormularioManifestacao />
      </AppBody>
    </AppFragment>
  );
};

export default IniciarOuvidoria;
